import React from "react";
import { MrCrudView } from "mr_react_framework";
import {
  DisordersList,
  DisordersColumns
} from "./DisordersListItems/DisordersList";
import DisorderHeader from "./DisorderHeader";
import NewBasicCRUDLayout from "../../components/Layouts/BasicCRUDLayout/NewBasicCRUDLayout";
import commonSelectors from "../../App/commonSelectors";
import DisorderItemDetail from "./DisorderItemDetail";
import CustomInput from "./CustomInput";

import { actions } from "./redux";
import { validateJsonValue } from "./validateJsonValue";

const returnDisorderForm = () => {
  let disorderForm = {
    processFormData: (dataProps, opts) => {
      console.log("dataProps", dataProps);
      console.log("opts", opts);
      // process and set values and then return changed values
      return opts.values;
    },
    schema: {
      type: "object",
      required: [
        
      ],
      properties: {
        name: {
          type: "string",
          default: "",
          title: "Disorder form name",
          span: 8,
        },
        abbreviation: {
          type: "string",
          default: "",
          title: "Abbreviation",
          span: 8,
        },
        form_code: {
          type: "string",
          default: "",
          title: "Form code",
          span: 8,
        },
        form_json: {
          type: 'string',
          span: 24,
          title: 'Disorder Fields',
          widget: CustomInput,
          trigger: 'onSubmit',
          formItemConfig: { noStyle: true },
          rules: [{
            validator(rule, value) {
              const valid = validateJsonValue(value.disorders);
              if (!valid.success) {
                return Promise.reject(valid.messages);
              } else {
                return Promise.resolve();
              }
            },
          }]
        },
      }
    }
  };

  return disorderForm;
};
const Disorders = MrCrudView({
  resourceName: "disorders",
  singleResourceName: "disorder",
  displayName: "Add Disorders Details",
  resourceUrl: "/disorders",
  // layout: NewBasicCRUDLayout,
  isRoute: true,
  // formLayout: NewBasicFormLayout,
  // tableColumns: PatientColumns,
  // filter: PatientsFilter,
  listHeader: <DisorderHeader />,
  listItem: DisordersList,
  forms: [{ name: "disorders", form: returnDisorderForm}],
  selectorsObj: {
    ...commonSelectors,
  },
  actions,
  // listHeader: <PatientsHeader />,
  actionNames: ["fetch", "create", "show", "update", "delete"],
  // firstTimeFetchParams: { with_users: true }
  config: {
    itemPreview: {
      // widget: DisordersList
      // use if we want cards
    },
    itemDetail: {
      // widget: (props) => {
      //   console.log( "itemDetail props", props );
      //   return <span>Item Detail {JSON.stringify(props.item)}</span>
      // }
      widget: DisorderItemDetail
    },
    pagination: {
      show: true,
    },
    filter: {
      show: true,
    },
    core: {
      setQueryParams: false,
    },
    list: {
      // use if we want custom table
      show: true,
      type: "table/list/custom",
      // widget: DisordersList,
      forceReload: true

    }
  },
});



export default Disorders;
